import { render, staticRenderFns } from "./holiday-saving-msg.vue?vue&type=template&id=0a3583fb&"
import script from "./holiday-saving-msg.vue?vue&type=script&lang=js&"
export * from "./holiday-saving-msg.vue?vue&type=script&lang=js&"
import style0 from "./holiday-saving-msg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports